import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './shared-access-empty-list.scss';

applyTranslations(require('./shared-access-empty-list.i18n.json'));

const SharedAccessEmptyList = (): JSX.Element => (
  <section className="shared-access-empty-list">
    <span className="shared-access-empty-list__text">
      {__t('shared_access_empty_list.text')}
    </span>
  </section>
);

export default SharedAccessEmptyList;
